import { Field, Form, Formik } from 'formik';
import { Modal } from 'react-bootstrap';
import FormLoader from '../../../shared-components/FormLoader/FormLoader';
import Label from '../../../shared-components/label/label';
import ModalFooter from '../../../shared-components/modal/modal-footer';
import FormikFormTextArea from '../../../shared-components/FormikFormHandlers/FormikFormTextArea';

export interface IRemoveTaskFormProps {
  id: string;
  initialValues: any;
  isLoading: boolean;
  submitHandler: (data: any) => void;
  onModalClosed: () => void;
}

const RemoveTaskForm = ({
  id,
  initialValues,
  isLoading,
  submitHandler,
  onModalClosed,
}: IRemoveTaskFormProps) => {
  return (
    <>
      <Formik
        initialValues={{ AbnormalityRemark: '' }}
        enableReinitialize
        // validationSchema={CodeValidateSchema}
        validateOnBlur={false}
        onSubmit={async (values) => {
          submitHandler({
            AbnormalityRemark: values.AbnormalityRemark,
          });
        }}
      >
        {() => {
          return (
            <Form className="user-form">
              {isLoading && <FormLoader loading={isLoading} />}
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <div className="form-group formSet">
                      <Label
                        className="label-style col-form-label"
                        required={false}
                        label="AbnormalityRemark"
                      />
                      {/* <Field
                        data-testid="testProcessName"
                        className="form-control"
                        name="AbnormalityRemark"
                        type="text"
                        placeholder=""
                        as={FormikFormInput}
                      /> */}
                      <Field
                        data-testid="testAbnormalityRemark"
                        className="form-control"
                        name="AbnormalityRemark"
                        type="text"
                        placeholder=""
                        as={FormikFormTextArea}
                      />
                    </div>
                  </div>
                </div>
              </Modal.Body>
              <ModalFooter
                id={Number(id)}
                onModalClosed={onModalClosed}
                isLoading={isLoading}
                saveNextBtn={'remove'}
                backCancelBtn="cancel"
              />
            </Form>
          );
        }}
      </Formik>
    </>
  );
};

export default RemoveTaskForm;
